import {
    GelRowLayout
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import RequirementDocuments from '../documentsupload/requirementDocuments';
import NextFuturePayment from '../nextFuturePayment/nextFuturePayment';
import ProcessedPayment from '../processedPayment/processedPayment';
import { NotificationType } from '../../../constants/constants';
import StatusUpdates from '../statusUpdate/statusUpdates';
import { useGetClaimDetailsContent } from '../../../common/api/graphQLDataFetch';
import { Requirements } from '../../../common/models/memberclaims';

interface NotificationItemProps {
    requirement: Requirements;
    memberNumber: string;
    superfundId: number;
}

const NotificationItem = (props: NotificationItemProps) => {
    const { global: { sizeBaseUnit } } = getGelTokens()
    const { requirement: { type, id, completedDate }, requirement, memberNumber, superfundId } = props;

    const { data } = useGetClaimDetailsContent()

    return (
        <GelRowLayout style={{
            paddingBottom: sizeBaseUnit * 4,
            paddingLeft: sizeBaseUnit * 4,
            paddingRight: sizeBaseUnit * 4,
        }}>
            {(type === NotificationType.ProceesedPayment) &&
                <ProcessedPayment key={id} payment={requirement} />}

            {(type === NotificationType.Activity) &&
                <StatusUpdates key={id} activity={requirement} notificationId={id} />}

            {type === NotificationType.FuturePayment &&
                <NextFuturePayment futurePayment={requirement} />
            }

            {(type !== NotificationType.ProceesedPayment
                && type !== NotificationType.Activity
                && type !== NotificationType.FuturePayment
                && !completedDate) &&
                <RequirementDocuments key={id}
                    contentFullData={data}
                    requirement={requirement}
                    memberNumber={memberNumber} superfundId={superfundId} />
            }
        </GelRowLayout>
    );
};

export default NotificationItem;